import { useState } from 'react';
import { useHistory } from 'react-router';
import { searchPathByKeyword } from '../../../utils/urlHelpers/boats';
import { definedValue, isIOS } from '../../../utils';

const focusedHeaderStyles = (focus) => {
  const luxury = document.querySelector('.luxury');
  if (luxury) {
    if (focus) {
      luxury.classList.add('focus-search');
    } else {
      const biggerAnimTime = 1000;
      setTimeout(() => {
        luxury.classList.remove('focus-search');
      }, biggerAnimTime);
    }
  }
};
// No need to cover this function since ios hacks don't deserve attention from civilized humans
/* istanbul ignore next */
const uglyIosOverlayHack = (focus) => {
  if (focus && isIOS()) {
    setTimeout(() => {
      try {
        const container = document.querySelector('.page-container');
        const iosOverlay = document.querySelector('.nav-overlay');
        if  (!iosOverlay || !container) {
          return;
        }
        const theHeight = getComputedStyle(container).height.replace('px', '');
        const height = Math.round(+theHeight);
        iosOverlay.style.height = height + 'px';
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }, 1);
  }
};

const getPlaceholder = (placeholderTxt, match) => {
  if (match?.params?.keyword) {
    return definedValue(match.params.keyword.split('-')[1], '');
  }
  return definedValue(placeholderTxt, '');
};

const useHeaderSearch = (searchTitle,  notFoundText, match) => {
  const [searchValue, setSearchValue] = useState('');

  const history = useHistory();
  // when we deal with predictive search, we will need to pass the options
  const options = [];

  const onKeyUp = (e) => {
    if (e.key === 'Enter') {
      gotoKeywordPage();
      return;
    }
    setSearchValue(e.target.value);
  };
  const gotoKeywordPage = () => {
    if (definedValue(searchValue, '').trim() === '') {
      return;
    }
    const newUrl = searchPathByKeyword(searchValue);
    history.push(newUrl);
  };
  const onSubmitSearch = (e) => {
    e.preventDefault();
  };
  const onSearchChange = () => {
    gotoKeywordPage();
  };
  const onFocusChange = (focus) => {
    // hackish way to deal with zIndex and focus styles
    focusedHeaderStyles(focus);
    uglyIosOverlayHack(focus);
  };
  const searchPlaceholder = getPlaceholder(searchTitle, match);

  const searchBox = {
    searchPlaceholder: searchPlaceholder,
    placeholder: searchTitle,
    emptyPlaceholder: searchPlaceholder,
    notFoundText,
    onSearchChange,
    options,
    onKeyUp,
    onFocusChange
  };
  return { searchBox, onSubmitSearch, onFocusChange, searchValue };
};

export { focusedHeaderStyles, useHeaderSearch };
